import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const LAYOUT_FEATURE_KEY = 'layout';

export interface LayoutState {
  isLoading: boolean;
  refetchData: boolean;
  showSidebar: boolean;
  showNavbar: boolean;
  error: string | null;
}

export const createInitialState = (): LayoutState => ({
  isLoading: false,
  refetchData: false,
  showSidebar: true,
  showNavbar: true,
  error: null,
});

const layoutSlice = createSlice({
  name: LAYOUT_FEATURE_KEY,
  initialState: createInitialState(),
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setShowSideBar(state, action: PayloadAction<boolean>) {
      state.showSidebar = action.payload;
    },
    setShowNavBar(state, action: PayloadAction<boolean>) {
      state.showNavbar = action.payload;
    },
    setRefetchData(state, action: PayloadAction<boolean>) {
      state.refetchData = action.payload;
    },
  },
});

const selectLayoutState = (
  state: { [LAYOUT_FEATURE_KEY]: LayoutState },
) => state[LAYOUT_FEATURE_KEY];

export const selectIsLoading = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.isLoading,
);

export const selectShowSidebar = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.showSidebar,
);

export const selectShowNavbar = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.showNavbar,
);

export const selectRefetchData = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.refetchData,
);

export const {
  setLoading,
  setError,
  setShowSideBar,
  setShowNavBar,
  setRefetchData,
} = layoutSlice.actions;

export default layoutSlice.reducer;
